module.exports = __webpack_public_path__ + "img/GLSNoPickupFee.8b4adc58.svg";